<template>
	<q-page padding>
		<div class="q-display-1 text-primary">
			<q-icon name="fas fa-list" class="q-mb-sm" /> {{ $t('users_groups') }}
		</div>

		<div class="row gutter-sm">
			<div class="col-xs-12 col-sm-12">
				<q-input
					v-model="title"
					:float-label="$t('title')"
					:error="$v.title.$error"
					@input="$v.title.$touch"
				/>
			</div>
		</div>

		<q-table
			ref="table"
			:data="members"
			:columns="columns"
			:filter="filter_members"
			selection="multiple"
			:selected.sync="selected"
			row-key="id"
			:pagination.sync="members_server_pagination"
			@request="request"
			:loading="loading"
			:no-data-label="$t('no_data_avaliable')"
			:no-results-label="$t('no_results_found')"
			:loading-label="$t('loading_data')"
			:rows-per-page-label="$t('items_per_page')"
			:rows-per-page-options="[5, 10, 50, 100]"
			binary-state-sort
			class="q-mt-lg"
		>
			<template slot="top" slot-scope="props">
				<div class="col" />
				<q-btn
					color="secondary"
					v-if="reportsPermission"
					class="q-mr-sm"
					icon="fas fa-download"
					:label="$t('group_report')"
					@click="downloadReport()"
				/>
				<q-btn
					color="negative"
					icon="fas fa-trash"
					:label="$t('remove')"
					@click="confirm_remove = true"
					v-if="selected.length > 0"
					class="q-mr-md"
				/>
				<q-btn
					color="secondary"
					icon="fas fa-plus"
					:label="$t('add_members')"
					@click="addMembers()"
				/>
			</template>

			<q-tr slot="header" slot-scope="props" :props="props">
				<q-th auto-width>
					<q-checkbox v-model="props.selected" indeterminate-value="some" />
				</q-th>

				<q-th v-for="col in props.cols" :key="col.name" :props="props">
					{{ $t(col.label) }}
				</q-th>
			</q-tr>

			<template slot="body" slot-scope="props">
				<q-tr :props="props">
					<q-td auto-width>
						<q-checkbox color="primary" v-model="props.selected" />
					</q-td>

					<q-td auto-width key="id" :props="props">
						{{ props.row.id }}
					</q-td>

					<q-td key="email" :props="props">
						{{ props.row.email }}
					</q-td>

					<q-td key="full_name" :props="props">
						{{ props.row.full_name }}
					</q-td>

					<q-td key="document" :props="props">
						{{ props.row.document }}
					</q-td>

					<q-td key="branches" :props="props">
						<q-btn
							color="primary"
							text-color="white"
							:label="getQuantityBranches(props.row.branches)"
							no-ripple
						>
							<q-tooltip v-if="props.row.branches.length > 0">
								<p class="tooltip q-mb-sm">
									{{ $t('branches') }}:
									<span
										v-for="(branch, index) in props.row.branches"
										:key="index"
									>
										{{ branch }}
										<span v-if="props.row.branches.length - 1 > index">, </span>
									</span>
								</p>
							</q-tooltip>
						</q-btn>
					</q-td>

					<q-td key="companies" :props="props">
						<q-btn
							color="primary"
							text-color="white"
							:label="getQuantityCompanies(props.row.companies)"
							no-ripple
						>
							<q-tooltip v-if="props.row.companies.length > 0">
								<p class="tooltip q-mb-sm">
									{{ $t('company') }}:
									<span
										v-for="(company, index) in props.row.companies"
										:key="index"
									>
										{{ company }}
										<span v-if="props.row.companies.length - 1 > index"
											>,
										</span>
									</span>
								</p>
							</q-tooltip>
						</q-btn>
					</q-td>

					<q-td key="profile" :props="props">
						{{ getProfile(props.row.profile) }}
					</q-td>
				</q-tr>
			</template>
		</q-table>

		<div class="row gutter-sm justify-end q-mt-lg">
			<div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
				<q-btn
					color="tertiary"
					class="full-width"
					:label="$t('back')"
					icon="fas fa-chevron-left"
					@click="$router.push({ name: 'admin_users_groups' })"
				/>
			</div>

			<div class="col-xs-12 col-sm-3" :class="getOrder('save')">
				<q-btn
					color="secondary"
					class="full-width"
					:label="$t('save')"
					icon="far fa-save"
					@click="saveData()"
				/>
			</div>
		</div>

		<!-- BUGGY MODAL - NEEDS FIX -->
		<q-modal
			v-if="show_add_members"
			v-model="show_add_members"
			:content-css="{ minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh' }"
			@hide="clearSelection()"
			@show="clearSelection()"
			@escape-key="clearSelection()"
		>
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn flat round dense @click="show_add_members = false" icon="fas fa-times" />
					<q-toolbar-title>
						{{ $t('group_members') }}
					</q-toolbar-title>
				</q-toolbar>

				<div class="layout-padding">
					<q-table
						:data="not_members"
						:columns="columns"
						:pagination.sync="not_members_server_pagination"
						:filter="filter_not_members"
						@request="requestNotMembers"
						:loading="loading"
						selection="multiple"
						:selected.sync="selected"
						row-key="id"
						:no-data-label="$t('realize_a_filter_to_show_results')"
						:no-results-label="$t('no_results_found')"
						:loading-label="$t('loading_data')"
						:rows-per-page-label="$t('items_per_page')"
						:rows-per-page-options="[5, 10, 50, 100]"
						binary-state-sort
					>
						<template slot="top" slot-scope="props">
							<div class="col-12">
								<div class="row gutter-sm">
									<div class="col-12">
										<q-search
											v-model="filter_not_members"
											icon="fas fa-search"
											:placeholder="$t('search')"
											:float-label="$t('search')"
											:debounce="500"
										/>
									</div>

									<div class="col-12">
										<q-select
											filter
											autofocus-filter
											chips
											multiple
											v-model="area"
											:options="getOptionsFilter.user_areas"
											:float-label="$t('knowledge_area')"
											@input="changeAddFilter()"
										/>
									</div>

									<div class="col-12">
										<q-select
											filter
											autofocus-filter
											chips
											multiple
											v-model="profile"
											:options="profiles"
											:float-label="$t('profiles')"
											@input="changeAddFilter()"
										/>
									</div>

									<div class="col-12">
										<q-chips-input
											v-model="companies_label"
											ref="companies_label"
											:float-label="$t('headquarters')"
											:debounce="600"
											@remove="removeCompany"
											clearable
											:disable="loading"
										>
											<q-autocomplete
												@search="fetchCompanies"
												@selected="selectCompanies"
												:min-characters="3"
												:max-results="50"
											/>
										</q-chips-input>
									</div>


									<div class="col-12">
										<q-chips-input
											v-model="stores_label"
											ref="stores_label"
											:float-label="$t('branches')"
											:debounce="600"
											@remove="removeStore"
											clearable
											:disable="loading"
										>
											<q-autocomplete
												@search="fetchStores"
												@selected="selectStores"
												:min-characters="3"
												:max-results="600"
											/>
										</q-chips-input>
									</div>

									<!-- <div class="col-12">
										<q-select
											filter
											autofocus-filter
											chips
											multiple
											v-model="branches"
											:options="stores"
											:float-label="$t('branches')"
											@input="changeAddFilter()"
											@virtual-scroll="() => onScrollStore()"
											:disable="companies_label.length ? false : true || loading"
										/>
									</div> -->
								</div>
								<div class="col-12 q-mt-md">
									<div class="flex justify-end">
										<q-btn
											color="primary"
											icon="fas fa-cloud-upload-alt"
											:label="$t('import')"
											@click="show_add_members_import = true"
											class="q-mr-md"
										/>
										<q-btn
											color="positive"
											icon="far fa-save"
											:label="$t('add_members')"
											@click="addSelectedMembers()"
											:disable="selected.length > 0 ? false : true"
											class="q-mr-md"
										/>
									</div>
								</div>
							</div>
						</template>

						<q-tr slot="header" slot-scope="props" :props="props">
							<q-th auto-width>
								<q-checkbox v-model="props.selected" indeterminate-value="some" />
							</q-th>

							<q-th v-for="col in props.cols" :key="col.name" :props="props">
								{{ $t(col.label) }}
							</q-th>
						</q-tr>

						<q-tr slot="body" slot-scope="props" :props="props">
							<q-td auto-width>
								<q-checkbox color="primary" v-model="props.selected" />
							</q-td>

							<q-td key="id" :props="props">
								{{ props.row.id }}
							</q-td>

							<q-td key="email" :props="props">
								{{ props.row.email }}
							</q-td>

							<q-td key="full_name" :props="props">
								{{ props.row.full_name }}
							</q-td>

							<q-td key="document" :props="props">
								{{ props.row.document }}
							</q-td>

							<q-td key="branches" :props="props">
								<q-btn
									color="primary"
									text-color="white"
									:label="getQuantityBranches(props.row.branches)"
									no-ripple
								>
									<q-tooltip v-if="props.row.branches.length > 0">
										<p class="tooltip q-mb-sm">
											{{ $t('branch') }}:
											<span
												v-for="(branch, index) in props.row.branches"
												:key="index"
											>
												{{ branch }}
												<span v-if="props.row.branches.length - 1 > index"
													>,
												</span>
											</span>
										</p>
									</q-tooltip>
								</q-btn>
							</q-td>

							<q-td key="companies" :props="props">
								<q-btn
									color="primary"
									text-color="white"
									:label="getQuantityCompanies(props.row.companies)"
									no-ripple
								>
									<q-tooltip v-if="props.row.companies.length > 0">
										<p class="tooltip q-mb-sm">
											{{ $t('company') }}:
											<span
												v-for="(company, index) in props.row.companies"
												:key="index"
											>
												{{ company }}
												<span v-if="props.row.companies.length - 1 > index"
													>,
												</span>
											</span>
										</p>
									</q-tooltip>
								</q-btn>
							</q-td>

							<q-td key="profile" :props="props">
								{{ getProfile(props.row.profile) }}
							</q-td>
						</q-tr>
					</q-table>
				</div>
			</q-modal-layout>
		</q-modal>

		<q-modal
			v-model="show_add_members_import"
			:content-css="{ minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh' }"
			@hide="clearSelection()"
			@show="clearSelection()"
			@escape-key="clearSelection()"
		>
			<q-modal-layout>
				<q-toolbar slot="header">
					<q-btn flat round dense @click="closeImport()" icon="fas fa-times" />
					<q-toolbar-title>
						{{ $t('import') }}
					</q-toolbar-title>
				</q-toolbar>

				<div class="layout-padding">
					<div class="row gutter-sm">
						<div class="col-12">
							<div class="row gutter-sm">
								<div class="col-xs-12 col-sm-6">
									<p class="caption">{{ $t('file') }}</p>
									<uploader
										content_type=""
										@fileUploaded="fileUploaded"
										:multiple="false"
									/>

									<p v-if="file_url" class="q-mt-md file-url">
										<q-icon name="fas fa-check" color="positive" />
										<a :href="file_url" target="_blank">
											{{ $truncateLink(file_url) }}</a
										>
									</p>
								</div>
							</div>
						</div>
					</div>

					<div class="row gutter-sm q-mt-lg">
						<div class="col-12">
							<h4 class="q-my-md">{{ $t('logs') }}</h4>
							<q-table
								:data="users_import"
								:columns="columns_logs"
								:filter="filter"
								row-key="line"
							>
								<q-tr slot="header" slot-scope="props" :props="props">
									<q-th v-for="col in props.cols" :key="col.name" :props="props">
										{{ $t(col.label) }}
									</q-th>
								</q-tr>

								<q-tr
									slot="body"
									slot-scope="props"
									:props="props"
									:class="props.row.exists === false ? 'bg-red-1' : ''"
								>
									<q-td key="id" :props="props">{{ props.row.id }}</q-td>
									<q-td key="email" :props="props">{{ props.row.email }}</q-td>
									<q-td key="exists" :props="props">{{
										props.row.exists == false
											? $t('user_not_found_or_incorrect')
											: ''
									}}</q-td>
								</q-tr>
							</q-table>
						</div>
					</div>
					<div class="row gutter-sm justify-end q-mt-lg">
						<div class="col-xs-12 col-sm-3" :class="getOrder('save')">
							<q-btn
								color="primary"
								class="full-width"
								:label="$t('import_test_template')"
								icon="far fa-file-alt"
								@click="generateTemplate()"
							/>
						</div>
						<div class="col-xs-12 col-sm-3" :class="getOrder('import')">
							<q-btn
								color="green"
								class="full-width"
								:label="$t('import')"
								icon="fas fa-check"
								@click="importUsers()"
							/>
						</div>
					</div>
				</div>
			</q-modal-layout>
		</q-modal>

		<q-dialog v-model="confirm_remove" @ok="removeMembers">
			<span slot="title">{{ $t('remove_item') }}</span>

			<span slot="message">{{ $t('confirm_remove_item') }}</span>

			<template slot="buttons" slot-scope="props">
				<q-btn color="primary" :label="$t('cancel')" @click="confirm_remove = false" />
				<q-btn color="negative" :label="$t('remove')" @click="removeMembers()" />
			</template>
		</q-dialog>
	</q-page>
</template>

<script>
import Uploader from 'components/Uploader'
import { mapGetters } from 'vuex'
import { required } from 'vuelidate/lib/validators'

export default {
	i18nOptions: { namespaces: ['custom', 'common', 'users', 'imports', 'login'] },

	components: {
		uploader: Uploader,
	},

	data() {
		return {
			members_server_pagination: {
				page: 1,
				rowsNumber: 10,
				rowsPerPage: 5,
				descending: false,
				sortBy: null,
			},
			not_members_server_pagination: {
				page: 1,
				rowsNumber: 10,
				rowsPerPage: 5,
				descending: false,
				sortBy: null,
			},
			loading: false,
			id_group: '',
			title: '',
			profile: [],
			area: [],
			company: [],
			members: [],
			not_members: [],
			columns: [
				{
					name: 'id',
					required: true,
					label: '#',
					align: 'left',
					field: 'name',
					sortable: false,
				},
				{
					name: 'email',
					required: true,
					label: 'email',
					align: 'left',
					field: 'email',
					sortable: false,
				},
				{
					name: 'full_name',
					required: true,
					label: 'name',
					align: 'left',
					field: 'full_name',
					sortable: false,
				},
				{
					name: 'document',
					required: true,
					label: 'document',
					align: 'left',
					field: 'document',
					sortable: false,
				},
				{
					name: 'branches',
					required: true,
					label: 'branch',
					align: 'left',
					field: 'branches',
					sortable: false,
				},
				{
					name: 'companies',
					required: false,
					label: 'company',
					align: 'left',
					field: 'companies',
					sortable: false,
				},
				{
					name: 'profile',
					required: true,
					label: 'profile',
					align: 'left',
					field: 'profile',
					sortable: false,
				},
			],
			filter_not_members: '',
			filter_members: '',
			selected: [],
			selected_not_members: [],
			show_add_members: false,
			confirm_remove: false,
			stores: [],
			store: [],
			branches: [],
			companies: [],
			companies_label: [],
			stores_label: [],
			show_add_members_import: false,
			file_url: '',
			users_import: [],
			columns_logs: [
				{
					name: 'id',
					required: true,
					label: '#',
					align: 'left',
					field: 'id',
					sortable: true,
				},
				{
					name: 'email',
					required: true,
					label: 'email',
					align: 'left',
					field: 'email',
					sortable: true,
				},
				{
					name: 'exists',
					required: true,
					label: '',
					align: 'left',
					field: 'exists',
					sortable: true,
				},
			],
			filter: '',
		}
	},

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			areas: 'registration_lists/areas',
			branch_regional: 'registration_lists/branch_regional',
			company_types: 'registration_lists/company_types',
			id: 'common/id',
			id_user_client_country_selected: 'common/id_user_client_country_selected',
			id_user_client_selected: 'common/id_user_client_selected',
			id_user_language_selected: 'common/id_user_language_selected',
			languages: 'params/languages',
			login_default_language_id: 'params/login_default_language_id',
			num_rows: 'datatable/num_rows',
			profiles: 'registration_lists/profiles',
			reload_content: 'common/reload_content',
			reports: 'registration_lists/reports',
			user_client_module_items: 'common/user_client_module_items',
			user_clients: 'common/user_clients',
		}),

		getHeader() {
			return {
				headers: {
					'content-type': 'application/json',
					authorization:
						'Basic ' +
						btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			}
		},

		getMaxWidth() {
			return this.$q.platform.is.mobile ? '100vw' : '90vw'
		},

		getMinWidth() {
			if (!this.$q.platform.is.mobile) return '90vw'
		},

		reportsPermission() {
			const obj = this.user_client_module_items.find(
				(obj) => obj.id === this.id_user_client_selected
			)
			if (obj) {
				const item = obj.module_items.find((obj) => obj.slug === 'reports')
				return item ? item.permission : false
			}
			return false
		},

		getOptionsFilter() {
			const client = this.user_clients.find((obj) => obj.id === this.id_user_client_selected)
			if (client) {
				return {
					user_areas: client.client_areas ? client.client_areas : [],
					profiles: client.client_profiles ? client.client_profiles : [],
					statuses: [
						{ value: 1, label: this.$t('active') },
						{ value: 2, label: this.$t('inactive') },
						{ value: 4, label: this.$t('awaiting_validation') },
						{ value: 5, label: this.$t('active_web_service') },
						{ value: 6, label: this.$t('self_registered') },
					],
					has_filter_store: true,
					has_filter_companies: true,
				}
			}
		},
	},

	methods: {
		request({ pagination }) {
			this.loading = true
			this.members_server_pagination = pagination

			const order = pagination.descending ? '-' : ''
			const order_by = pagination.sortBy ? order + pagination.sortBy : ''

			const data = {
				page_size: this.members_server_pagination.rowsPerPage,
				page: this.members_server_pagination.page,
				search: this.filter_members,
				ordering: order_by,
			}

			this.$axios
				.get(
					`/admin_group_users/group_users/${
						this.id_group
					}/get_group_members/?${this.$qs.stringify(data)}`,
					this.getHeader
				)
				.then((response) => {
					this.members = []
					this.members_server_pagination.rowsNumber = response.data.count

					response.data.results.forEach((member) => {
						const branches = []
						const companies = []

						member.branches.forEach((branch) => {
							branches.push(branch)
						})

						member.companies.forEach((company) => {
							companies.push(company)
						})

						this.members.push({
							id: member.id,
							email: member.email,
							full_name: member.full_name,
							document: member.document,
							branches: branches,
							profile: member.profile,
							companies: companies,
							selected: false,
						})
					})

					this.loading = false
				})
				.catch((e) => {
					this.loading = false
					console.log(e)
				})
		},

		requestNotMembers({ pagination }) {
			if (
				this.profile.length > 0 ||
				this.area.length > 0 ||
				this.branches.length > 0 ||
				this.companies.length > 0 ||
				this.filter_not_members != ''
			) {
				this.loading = true
				this.not_members_server_pagination = pagination

				const order = pagination.descending ? '-' : ''
				const order_by = pagination.sortBy ? order + pagination.sortBy : ''

				const data = {
					page_size: this.not_members_server_pagination.rowsPerPage,
					page: this.not_members_server_pagination.page,
					search: this.filter_not_members,
					ordering: order_by,
					profiles: this.profile,
					areas: this.area,
					branches: this.store,
					companies: this.company,
				}

				this.$axios
					.get(
						'/admin_group_users/group_users/' +
							this.id_group +
							'/get_group_not_members/?' +
							this.$qs.stringify(data, { arrayFormat: 'repeat' }),
						this.getHeader
					)
					.then((response) => {
						this.not_members_server_pagination.rowsNumber = response.data.count

						this.not_members = []

						response.data.results.forEach((member) => {
							const branches = []
							const companies = []

							member.branches.forEach((branch) => {
								branches.push(branch)
							})

							member.companies.forEach((company) => {
								companies.push(company)
							})

							this.not_members.push({
								id: member.id,
								email: member.email,
								full_name: member.full_name,
								document: member.document,
								branches: branches,
								companies: companies,
								profile: member.profile,
							})
						})

						this.loading = false
					})
					.catch((e) => {
						this.loading = false
						console.log(e)
					})
			} else {
				this.not_members = []
			}
		},

		fetchData() {
			this.$q.loading.show()
			
			this.$axios
				.get('/admin_group_users/group_users/' + this.id_group + '/', this.getHeader)
				.then((response) => {
					this.title = response.data.title

					this.request({ pagination: this.members_server_pagination })
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		saveData(type) {
			this.$v.$touch()

			if (!this.$v.$error) {
				this.$q.loading.show()

				let fd = new FormData()
				fd.append('title', this.title)

				this.area.forEach((area) => {
					fd.append('areas', area)
				})

				if (this.id_group != 0) {
					this.$axios
						.put(
							'/admin_group_users/group_users/' + this.id_group + '/',
							fd,
							this.getHeader
						)
						.then(() => {
							this.$q.loading.hide()
							if (type != 'add_members')
								this.$router.push({ name: 'admin_users_groups' })
							else this.show_add_members = true
						})
						.catch((e) => {
							this.$q.loading.hide()
							console.log(e)
						})
				} else {
					this.$axios
						.post('/admin_group_users/group_users/', fd, this.getHeader)
						.then((response) => {
							this.$q.loading.hide()

							this.id_group = response.data.id
							this.$router.push({
								name: 'admin_users_group',
								params: { id: response.data.id },
							})
							this.show_add_members = true
						})
						.catch((e) => {
							this.$q.loading.hide()
							console.log(e)
						})
				}
			} else {
				this.$q.notify({
					message: this.$t('make_sure_that_all_fields_are_filled_in'),
					type: 'negative',
					icon: 'fas fa-exclamation-triangle',
					position: 'top',
				})
			}
		},

		addMembers() {
			this.$v.$touch()

			if (!this.$v.$error) {
				if (this.id_group == 0) {
					this.saveData('new_group')
				} else {
					this.show_add_members = true
				}
			}
		},

		addSelectedMembers() {
			this.$q.loading.show()

			let fd = new FormData()

			this.selected.forEach((member) => {
				fd.append('members', member.id)
			})

			this.$axios
				.post(
					'/admin_group_users/group_users/' + this.id_group + '/add_group_members/',
					fd,
					this.getHeader
				)
				.then(() => {
					this.$q.loading.hide()
					this.request({ pagination: this.members_server_pagination })
					this.show_add_members = false
				})
				.catch((e) => {
					this.$q.loading.hide()
					console.log(e)
				})
		},

		changeAddFilter() {
			this.requestNotMembers({
				pagination: {
					page: 1,
					rowsNumber: 10,
					rowsPerPage: 5,
					descending: false,
					sortBy: null,
				},
			})
		},

		removeMembers() {
			this.$q.loading.show()

			let fd = new FormData()

			this.selected.forEach((member) => {
				fd.append('members', member.id)
			})

			this.$axios
				.post(
					'/admin_group_users/group_users/' + this.id_group + '/del_group_members/',
					fd,
					this.getHeader
				)
				.then(() => {
					this.$q.loading.hide()
					this.request({ pagination: this.members_server_pagination })
					this.confirm_remove = false
				})
				.catch((e) => {
					this.$q.loading.hide()
					console.log(e)
				})
		},

		clearSelection() {
			this.not_members = []
			this.selected = []
			this.area = []
			this.profile = []
			this.filter_not_members = ''
			this.companies = []
			this.companies_label = []
			this.stores_label = []
			this.stores = []
			this.branches = []
		},

		getProfile(id) {
			let obj = this.profiles.find((obj) => obj.value === id)
			return obj ? obj.label : ''
		},

		getQuantityBranches(branches) {
			return branches.length > 0 ? branches.length : '0'
		},

		getQuantityCompanies(companies) {
			return companies.length > 0 ? companies.length : '0'
		},

		async loadStores() {
			this.loading = true
			this.stores = []
			this.branches = []
			
			let data = {
				page_size: 200,
				page: 1,
				country: this.id_user_client_country_selected,
				company: this.company,
			}
			await this.$axios
				.get(
					`/admin_companies/branches/?${this.$qs.stringify(data, {
						arrayFormat: 'repeat',
					})}`,
					this.getHeader
				)
				.then((response) => {
					this.stores = response.data.results.map((e) => {
						return {
							...e,
							value: e.id,
							label: `${e.name} / ${
								e.document && e.register
									? `${e.document} - ${e.register}`
									: e.document
									? e.document
									: e.register
									? e.register
									: ''
							}`,
						}
					})
				})
				.catch((e) => {
					this.loading = false
					console.log(e)
				})
			this.loading = false
		},

		fetchCompanies(terms, done) {
			this.$axios
				.get(`/admin_companies/companies/get_companies/?search=${terms}`, this.getHeader)
				.then((response) => {
					this.companies = response.data.map((element) => {
						return {
							value: `${element.name} / ${this.$t(element.company_type_label)} ${
								element.document && element.register
									? `${element.document} - ${element.register}`
									: element.document
									? element.document
									: element.register
									? element.register
									: ''
							}`,
							label: `${element.name} / ${this.$t(element.company_type_label)} ${
								element.document && element.register
									? `${element.document} - ${element.register}`
									: element.document
									? element.document
									: element.register
									? element.register
									: ''
							}`,
							id: element.id,
						}
					})

					done(this.companies)
				})
				.catch((e) => {
					done([])
					console.log(e)
				})
		},

		selectCompanies(item) {
			let obj = this.companies.find((obj) => obj.id === item.id)
			if (!obj) {
				this.companies.push(item)
			}
			
			this.company.push(item.id)
		},

		removeCompany({ index, value }) {
			this.company.splice(index, 1)
			this.branch = []
		},

		async fetchStores(terms, done) {
			let data = {
				page_size: 600,
				page: 1,
				country: this.id_user_client_country_selected,
				company: this.company,
				search: terms
			}
			await this.$axios
				.get(
					`/admin_companies/branches/?${this.$qs.stringify(data, {
						arrayFormat: 'repeat',
					})}`,
					this.getHeader
				)
				.then((response) => {
					this.stores = response.data.results.map((e) => {
						return {
							...e,
							value: `${e.name} / ${
								e.document && e.register
									? `${e.document} - ${e.register}`
									: e.document
									? e.document
									: e.register
									? e.register
									: ''
							}`,
							label: `${e.name} / ${
								e.document && e.register
									? `${e.document} - ${e.register}`
									: e.document
									? e.document
									: e.register
									? e.register
									: ''
							}`,
							id: e.id
						}
					})
					done(this.stores)
				})
				.catch((e) => {
					this.loading = false
					this.$q.loading.hide()
					done([])
					console.log(e)
				})
		},

		selectStores(item) {
			let obj = this.stores.find((obj) => obj.id === item.id)
			if (!obj) {
				this.stores.push(item)
			}
			
			this.store.push(item.id)
			this.changeAddFilter()
		},

		removeStore({ index, value }) {
			this.store.splice(index, 1)
			this.stores_label = []
			
			if (this.store.length > 0) this.changeAddFilter()
		},

		downloadReport() {
			const message = this.$t('generating_import_file_message')
			this.$q.loading.show({
				message,
			})
			this.$axios
				.get(
					`/admin_group_users/group_users/${this.id_group}/generate_report/`,
					this.getHeader
				)
				.then((response) => {
					this.forceFileDownload(response.data.path_url)
				})
				.catch((e) => {
					this.loading = false
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		forceFileDownload(response) {
			const link = document.createElement('a')
			link.href = response
			document.body.appendChild(link)
			link.click()
		},

		fileUploaded(url) {
			this.file_url = url
			this.file_url_complete = url
			this.validateLines()
		},

		generateTemplate() {
			const message = this.$t('generating_import_file_message')
			this.$q.loading.show({
				message,
			})
			this.$axios
				.get(
					`/admin_import/group_user_members_import/${this.id_group}/generate_template/`,
					this.getHeader
				)
				.then((response) => {
					this.forceFileDownload(response.data.path_url)
				})
				.catch((e) => {
					console.log(e)
				})
				.finally(() => {
					this.$q.loading.hide()
				})
		},

		validateLines() {
			const data = { file_url: this.file_url }
			this.$axios
				.post(
					`/admin_import/group_user_members_import/${this.id_group}/validate_template/`,
					data,
					this.getHeader
				)
				.then((response) => {
					this.$q.loading.hide()
					this.users_import = response.data.users
					this.users_import.sort((a, b) => {
						if (a.exists > b.exists) return 1
						if (a.exists < b.exists) return -1
						return 0
					})
				})
				.catch((e) => {
					this.$q.loading.hide()
					console.log(e)
				})
		},

		importUsers() {
			const data = { users: this.users_import }
			this.$axios
				.post(
					`/admin_import/group_user_members_import/${this.id_group}/start_import/`,
					data,
					this.getHeader
				)
				.then(() => {
					this.$q.loading.hide()
					this.show_add_members = false
					this.show_add_members_import = false
					this.fetchData()
					this.$q.notify({
						message: this.$t('save_data_success'),
						type: 'positive',
						icon: 'fas fa-check',
					})
					this.clearImport()
				})
				.catch((e) => {
					this.$q.loading.hide()
					console.log(e)
					this.clearImport()
				})
		},

		clearImport() {
			this.file_url = ''
			this.users_import = []
		},

		closeImport() {
			this.show_add_members_import = false
			this.clearImport()
		},

		getOrder(name) {
			if (name == 'validate') {
				return this.$q.platform.is.mobile ? 'order-first' : 'order-last'
			} else if (name == 'import') {
				this.$q.platform.is.mobile ? 'order-first' : 'order-last'
			}
		},
	},

	created() {
		this.id_group = this.$route.params.id
		if (this.id_group != 0) this.fetchData()
	},

	validations() {
		return {
			title: { required },
		}
	},
}
</script>
